import React from "react";
import EntityRanking from "../EntityRanking";
import { PROVIDERS, PROVIDER_NAMES } from "../catalog";

export default function Providers() {
  return (
    <EntityRanking title="Provedores" meta="Provedores do catálogo, ordenados por volume de eventos."
      field="provider" items={PROVIDERS} nameHeader="Provedor" testid="providers"
      extraCols={[{ key: "gamesCount", label: "Jogos" }]}
      renderName={(p) => <span className="font-medium">{PROVIDER_NAMES[p.id] || p.name}</span>} />
  );
}
